import { OnInit, Component, EventEmitter, Input, Output, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { ApiRequest, FunctionPackageEnum, IApiresponse } from "../../../../_models";
import { OrganisationFunctionService } from "../../../../_services/organisation-setting/organisation-function.service";
import { SelectExpenseCategoryPopupModel } from "../../../../_models/claimant-on-web/claimant-on-web";
import { GetAndSaveItemBrandsReqResp, GetVendorListRequest, ItemBrand, VendorListResponse } from "../../../../_models/vendor/vendor.model";
import { Claims } from "../../../../_models/common/claims";
import { ClaimsService } from "../../../../_services/common/claims.service";
import { environment } from "../../../../../environments/environment";
import { VendorService } from "../../../../_services/vendor/vendor.service";
@Component({
  selector: "select-brand-panel",
  templateUrl: "./select-brand-panel.component.html",
  standalone: false
})
export class SelectBrandPanelComponent implements OnInit, OnDestroy {

  @Input()
  inputData: any;

  @Output() closePanelEvent = new EventEmitter<boolean>();
  @Output() submitPanelEvent = new EventEmitter<any>();

  claimsSubscription: Subscription;
  claims: Claims;
  param: any;
  orgExpenseCategoryList = <any[]>[];
  recentCategoryList: any = [];
  selectedOrgExpenseCategoryId: number = 0;
  outputModel: any;
  showPopUpForNoCategorySetup: boolean;
  isAdvancesDisplay: boolean = false;
  advancesList: any[] = [];
  selectedAdvanceId: number = 0;
  isAssignCategoriesToGradePurchased: boolean = false;
  isSupplierPurchased: boolean = false;
  hasReciept : boolean=false;

  list: ItemBrand[] = [];
  constructor(
    private claimsService: ClaimsService,
    private translate: TranslateService,private vendorService: VendorService,private cdr: ChangeDetectorRef
  ) {
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit() {
    this.GetBrandList();
    //this.fnSetExpenseCategoryInputValues();
  }

  ngOnDestroy(): void {
    this.claimsSubscription.unsubscribe();
  }

GetBrandList() {
  let request = new ApiRequest<GetAndSaveItemBrandsReqResp>(
    "GetItemBrands",
    environment.applicationVersion,
    environment.requestId
  );
  let requestInfo = new GetAndSaveItemBrandsReqResp();
  requestInfo.action = 4;
  requestInfo.orgId = this.claims.OrgId;
  request.requestInfo = requestInfo;


  this.vendorService
    .GetItemBrands(request)
    .subscribe((response: IApiresponse<GetAndSaveItemBrandsReqResp>) => {
      if(response){
        this.list = response.responseInfo.itemBrands;      
        this.cdr.detectChanges();   
      }
    });
}
fnSelect(item: ItemBrand) {
    if (item) {      
      this.outputModel = {
        itemBrandId: item.itemBrandId,
        brandName:item.brandName
      };
      this.submitPanelEvent.emit(this.outputModel);
    }
  }

  fnClosePanel(isClose: boolean) {
    this.closePanelEvent.emit(isClose);
  }
  // fnSetExpenseCategoryInputValues() {
  //   if (this.inputData) {
  //     this.selectedOrgExpenseCategoryId = this.inputData.orgExpenseCategoryId;
  //   }
  // }
  



}
